import React, { SVGProps, ReactElement } from 'react';
import { useTheme } from '../theming';
import { fallbackTheme } from '../theming/fallbackTheme';

export type InternalIconProps = {
  children: ReactElement | ReactElement[];
  props?: SVGProps<SVGSVGElement>;
};

export function GenericFlagIcon({ children, ...otherProps }: InternalIconProps) {
  const currentTheme = useTheme();
  const pathColor = fallbackTheme(currentTheme).color.lines.default;

  return (
    <svg
      focusable={false}
      aria-hidden={true}
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      {...otherProps}
    >
      {children}
      <path
        d="M16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16C29 23.1797 23.1797 29 16 29Z"
        stroke={pathColor}
        strokeWidth={2}
      />
    </svg>
  );
}

// export const GenericFlagIcon = forwardRef(_Icon);
